import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card-header header-elements-inline" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "header-elements" }
const _hoisted_4 = {
  key: 0,
  class: "list-icons ml-3"
}
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  class: "list-icons-item dropdown-toggle",
  "data-toggle": "dropdown"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-exclamation text-danger icon-2x" })
], -1)
const _hoisted_7 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "icon-sync" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-body d-none" }, null, -1)
const _hoisted_10 = { class: "list-group border-x-0 rounded-0" }
const _hoisted_11 = { class: "list-group-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Objekt-Id:")
], -1)
const _hoisted_13 = {
  href: "#",
  class: "font-italic"
}
const _hoisted_14 = { class: "list-group-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-map4 mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Anschrift:")
], -1)
const _hoisted_16 = { class: "ml-auto d-flex flex-column align-items-end" }
const _hoisted_17 = { class: "list-group-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-mention mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Ansprechpartner:")
], -1)
const _hoisted_19 = { class: "ml-auto d-flex flex-column align-items-end" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "card-footer text-right" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Zum Objekt ")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "card",
    onMouseout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('kekse')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.project_name), 1),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.errors)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.signals?.errors, (error, index) => {
                    return (_openBlock(), _createElementBlock("a", {
                      key: index,
                      class: "dropdown-item",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showSystems && _ctx.showSystems(...args)))
                    }, [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(error.text), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_9,
    _createElementVNode("ul", _hoisted_10, [
      _createElementVNode("li", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", {
          class: "ml-auto",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToObject && _ctx.goToObject(...args)))
        }, [
          _createElementVNode("a", _hoisted_13, "#" + _toDisplayString(_ctx.data.pid), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.data.p_strasse) + " " + _toDisplayString(_ctx.data.p_hnr) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.data.p_plz) + " " + _toDisplayString(_ctx.data.p_ort), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createTextVNode(_toDisplayString(_ctx.data.p_vorname) + " " + _toDisplayString(_ctx.data.p_name) + " ", 1),
          _createElementVNode("a", {
            href: 'mailto:'+_ctx.data.p_email,
            class: "font-italic"
          }, _toDisplayString(_ctx.data.p_email), 9, _hoisted_20)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("button", {
        class: "btn btn-secondary btn-sm",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToObject && _ctx.goToObject(...args)))
      }, _hoisted_24)
    ])
  ], 32))
}